/** Design Direction: Minimal Clean | DQS: 13/15 | Differentiation: mirrors existing AI message bubble structure exactly */

export function TypingIndicator() {
  return (
    <div className="flex justify-end" aria-label="Agente IA está digitando">
      <div className="max-w-[80%] sm:max-w-[65%]">
        <p className="text-xs text-muted-foreground mb-1 text-right">Agente IA</p>
        <div className="rounded-lg border px-4 py-3 bg-muted text-foreground border-border inline-flex items-center gap-1">
          <span
            className="w-2 h-2 rounded-full bg-muted-foreground/60 animate-bounce motion-reduce:animate-none"
            style={{ animationDelay: '0ms', animationDuration: '0.9s' }}
          />
          <span
            className="w-2 h-2 rounded-full bg-muted-foreground/60 animate-bounce motion-reduce:animate-none"
            style={{ animationDelay: '0.15s', animationDuration: '0.9s' }}
          />
          <span
            className="w-2 h-2 rounded-full bg-muted-foreground/60 animate-bounce motion-reduce:animate-none"
            style={{ animationDelay: '0.3s', animationDuration: '0.9s' }}
          />
        </div>
      </div>
    </div>
  );
}
